function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.562 4.341V1.688C13.562.756 12.806 0 11.874 0H8.126c-.932 0-1.688.756-1.688 1.688v2.653h7.124zm-5.999 0V1.688c0-.309.253-.562.563-.562h3.749c.309 0 .562.253.562.562v2.653M12.437 8.18H7.563a.564.564 0 00-.562.562v3.998c0 .31.253.562.562.562h4.874a.564.564 0 00.562-.562V8.743a.564.564 0 00-.562-.563zm-.563 3.998H8.126V9.305h3.749v2.873h-.001z",
  fill: "#111"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.312 4H1.688C.756 4 0 4.756 0 5.687v4.744c0 .736.474 1.355 1.131 1.586-.089.206-.14.432-.14.67v3.625c0 .932.756 1.688 1.687 1.688h14.643c.932 0 1.688-.756 1.688-1.688v-3.625a1.68 1.68 0 00-.14-.67A1.682 1.682 0 0020 10.431V5.687C20 4.756 19.244 4 18.312 4zm.563 6.431a.564.564 0 01-.562.562h-5.876v1.131h4.885c.309 0 .562.253.562.562v3.625a.564.564 0 01-.562.562H2.678a.564.564 0 01-.562-.562v-3.625c0-.309.253-.562.562-.562h4.885v-1.131H1.688a.564.564 0 01-.562-.562V5.687c0-.309.253-.562.562-.562h16.625c.309 0 .562.253.562.562v4.744z",
  fill: "#111"
});

function SvgAmenitiesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgAmenitiesIcon;